import { v5 as uuidv5 } from 'uuid';

export function getOrderTotal({ cart }) {
  return cart.items.reduce((t, i) => parseFloat(t) + parseFloat(i.subtotal), 0.00000);
}

export const isSameBreakdown = (breakdown1, breakdown2, group_by_color=false) => {
  const match =
    breakdown1.item_id === breakdown2.item_id &&
    (group_by_color || breakdown1.size_id === breakdown2.size_id) &&
    breakdown1.color_id === breakdown2.color_id &&
    breakdown1.product_sku_id === breakdown2.product_sku_id;

  if (!match) return false;
  if (!breakdown1.product_questions && !breakdown2.product_questions) return true;
  if (!breakdown1.product_questions || !breakdown2.product_questions) return false;

  const product_questions1 = breakdown1.product_questions;
  const product_questions2 = breakdown2.product_questions;

  if (Object.keys(product_questions1).length !== Object.keys(product_questions2).length) return false;
  return Object.values(product_questions1).every((question1) => {
    const question2 = product_questions2[question1.metadata_id];
    return question2 && question2.label === question1.label && question2.value === question1.value;
  });
};

export function getCartForPopupShops({ cart }) {
  const newItems = [];
  cart.items.forEach(item => {
    item.breakdowns.forEach(b => {
      const breakdownGroup = newItems.find(newItem =>
        newItem.item_id === item.item_id && isSameBreakdown(newItem.breakdowns[0], b, true));
      if (breakdownGroup) {
        breakdownGroup.breakdowns.push(b);
        breakdownGroup.quantity += b.quantity;
        breakdownGroup.subtotal += b.subtotal;
      } else {
        const cart_item_id = `${item.item_id}-${b.product_sku_id ?? b.color_id}-${b.product_questions
          ? JSON.stringify(
              Object.values(b.product_questions)
                .sort((a, b) => a.metadata_id.localeCompare(b.metadata_id))
                .map(q => ({ metadata_id: q.metadata_id, label: q.label, value: q.value}))
            )
          : ''}`;
        newItems.push({
          ...item,
          breakdowns: [b],
          quantity: b.quantity,
          subtotal: b.subtotal,
          cart_item_id: uuidv5(cart_item_id, uuidv5.URL)
        });
      }
    });
  });
  return { ...cart, items: newItems };
}

export function isTotalOk({ per_checkout_limit, orderTotal }) {
  return per_checkout_limit ?
    orderTotal <= per_checkout_limit :
    true;
}

export function isArtworkOk({ client_id, cart }) {
  return !!client_id || cart.items.reduce((ok, i) => ok && i.artworks.reduce((ok2, a) => ok2 && !!a.image, true), true);
}

export function isMinimumQuantityOk({ buy_inventory, force_minimum_qty, aggregate, cart }) {
  const itemInCart = !!cart.items.length;
  return itemInCart && cart.items.reduce((ok, i) => {
    if (!ok) {
      return ok;
    }
    if (!buy_inventory && i.inventory_items.length > 0) {
      // If this is an item with inventory and we are not buying inventory do nothing
      return i.quantity > 0;
    } else if ((aggregate == 1 && force_minimum_qty == 1) || aggregate == 0) {
      return i.quantity >= i.minimum_quantity;
    } else {
      return i.quantity > 0;
    }
  }, true);
}

export function isShopQuantityOk({ is_free_shop, items, free_items_count=1, allow_multiple_free_item=1, }) {
  if (+is_free_shop !== 1 || items.length === 0) {
    return true;
  }

  let count = 0;
  let quantities = {};
  for (const item of items) {
    if (+item.quantity === 0) {
      continue;
    }

    if (!quantities[item.item_id]) {
      quantities[item.item_id] = 0;
    }
    count += +item.quantity;
    if (count > free_items_count) {
      return false;
    }
    quantities[item.item_id] = +(quantities[item.item_id] ?? '0') + +item.quantity;
    if (+allow_multiple_free_item !== 1 && quantities[item.item_id] > 1) {
      return false;
    }
  }

  return true;
}

